// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"079eaf11","258":"2f365f86","264":"4c272835","465":"8e353b63","547":"24b50dbb","585":"4414dba8","665":"05fd3197","875":"1ccfe774"}[chunkId] + ".chunk.css";
};